import React, { useEffect, useState }  from "react";
import "./Tables.scss";
import { useHistory, useLocation} from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import { Box, Tab, Typography } from "@mui/material";
import Stations from "src/features/tables/station-table/Stations";
import { SiteTable } from "src/features/tables/site-tables";
import { ROUTE_PATHS } from "src/routes/paths";
import StationDetails from "src/features/tables/station-table/StationDetails"; 
import { Catalogs } from "../catalogs/Catalogs";
import { checkAdminRole } from "src/store/common";
import { useStoreContext } from 'src/store/context';
import { getAccessTokenCookie } from "src/shared/Login";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          style={{padding:0, margin:0}}
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
          {value === index && <Box>{children}</Box>}
      </div>
  );
};
function a11yProps(index: number) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}

export function StationDetail({ setTabValue }) {
  return (
    <Box>
      {/* Add your existing code here */}
      <Box mt={1}>
        <Typography
          variant="body2"
          color="primary"
          sx={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => {
            setTabValue(0); // Switch to the "Stations" tab
          }}
        >
          View All Stations
        </Typography>
      </Box>
    </Box>
  );
}
const routes = [ROUTE_PATHS.stations, ROUTE_PATHS.field_sample_sites, ROUTE_PATHS.fuelTab]

export const Tables = () => {
  const history = useHistory();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(location.pathname?.includes(ROUTE_PATHS.field_sample_sites)? 1:location.pathname?.includes(ROUTE_PATHS.catalogs)? 2:0);
  const [state] = useStoreContext();

  useEffect(()=>{
    if(location.pathname===ROUTE_PATHS.table){
      history.push(`${ROUTE_PATHS.table}${routes[0]}`)
    }
    if (location?.pathname?.includes(ROUTE_PATHS.stations)) {
      setTabValue(0)
    }
    else if(location.pathname?.includes(ROUTE_PATHS.catalogs)){
      if(getAccessTokenCookie('accessToken')){
        setTabValue(2)
      }
      else{
        history.push(`${ROUTE_PATHS.table}${routes[0]}`)
      }
    }   
    else if(location.pathname?.includes(ROUTE_PATHS.field_sample_sites)){
      setTabValue(1)
    }
  },[history, location.pathname])
  return (
    <div style={{padding: '.1%'}}>
      
      <Tabs 
        scrollButtons={false}
        value={tabValue}
        onChange={(event, newVal)=>{
          setTabValue(newVal); 
          history.push(`${ROUTE_PATHS.table}${routes[newVal]}`)
        }}
        className="subtabs"

      >
        <Tab label="Stations" {...a11yProps(0)}/>    
        <Tab label="Field Sample Sites"{...a11yProps(1)}/>
        {
          state.user && checkAdminRole(state.user) && 
          <Tab label="NFDRS Catalogs" {...a11yProps(2)}/>
        }    
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        {
          location.pathname?.includes('tables/fireDanger/') &&
          <StationDetails tab={0}/>
        }
        {
          location.pathname?.includes('tables/weather/') &&
          <StationDetails tab={1}/>
        }
        {
          location.pathname?.includes('tables/stationMetaData/') &&
          <StationDetails tab={2}/>
        }
        {
          location.pathname?.includes('tables/catalog/') &&
          <StationDetails tab={3}/>
        }
        {
          location.pathname?.includes('tables/charts/') &&
          <StationDetails tab={4}/>
        }
        {
          location.pathname?.includes('stations') &&
          <Stations/>
 
        }
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <SiteTable/>
      </TabPanel>
      {
        state.user && checkAdminRole(state.user) && 
        <TabPanel value={tabValue} index={2}>
          <Catalogs/>
        </TabPanel>
      }
    </div>
  );
};
